import router from '@/router';

const OCRoutes = [
  {
    path: 'admin/missing_invoices',
    name: 'MissingInvoice',
    component: {
      name: 'AdminMissingInvoices',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'missing_invoice',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminMissingInvoiceIndex',
        component: () => import('../views/MissingInvoicesIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
    ],
  },
  {
    path: 'admin/invoice_dashboard',
    name: 'AdminInvoiceDashboard',
    component: () => import('../views/InvoiceDashboard.vue'),
    meta: {
      customName: 'views.invoice.invoice_dashboard',
    },
  },
  {
    path: 'admin/invoices',
    name: 'Invoice',
    component: {
      name: 'AdminInvoices',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'invoice',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminInvoiceIndex',
        component: () => import('../views/InvoicesIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'AdminInvoiceNew',
        component: () => import('../views/InvoiceInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'AdminInvoiceIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminInvoiceShow',
        component: () => import('../views/InvoiceShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminInvoiceIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminInvoiceDetails',
            component: () => import('../views/InvoiceDetails.vue'),
            meta: {
              backRoute: { name: 'AdminInvoiceIndex' },
            },
          },
          {
            path: 'phases',
            name: 'AdminInvoicePhases',
            component: () => import('../views/InvoicePhases.vue'),
            meta: {
              backRoute: { name: 'AdminInvoicesIndex' },
              resource: 'phase',
            },
          },
          {
            path: 'logs',
            name: 'AdminInvoiceLogs',
            component: () => import('../views/InvoiceLogs.vue'),
            meta: {
              backRoute: { name: 'AdminInvoiceIndex' },
              resource: 'log',
            },
          },
          {
            path: 'edit',
            name: 'AdminInvoiceEdit',
            component: () => import('../views/InvoiceInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminInvoiceDetails' },
            },
          },
          {
            path: 'send',
            name: 'AdminInvoiceSend',
            component: () => import('../views/InvoiceSend.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminInvoiceIndex' },
              customName: 'views.invoice.approve_concept',
            },
          },
          {
            path: 'send_po_request',
            name: 'AdminInvoiceSendPoRequest',
            component: () => import('../views/InvoiceSendPoRequest.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminInvoiceIndex' },
              customName: 'views.invoice.send_po_request',
            },
          },
        ],
      },
    ]
  },
  {
    path: 'admin/invoice_pendings',
    name: 'InvoicePending',
    component: {
      name: 'AdminInvoicePendings',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'invoice_pending',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminInvoicePendingIndex',
        component: () => import('../views/InvoicesIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'AdminInvoicePendingNew',
        component: () => import('../views/InvoiceInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'AdminInvoicesPendingIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminInvoicePendingShow',
        component: () => import('../views/InvoiceShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminInvoicesPendingIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminInvoicePendingDetails',
            component: () => import('../views/InvoiceDetails.vue'),
            meta: {
              backRoute: { name: 'AdminInvoicesPendingIndex' },
            },
          },
          {
            path: 'logs',
            name: 'AdminInvoicePendingLogs',
            component: () => import('../views/InvoiceLogs.vue'),
            meta: {
              backRoute: { name: 'AdminInvoicesPendingIndex' },
              resource: 'log',
            },
          },
          {
            path: 'edit',
            name: 'AdminInvoicePendingEdit',
            component: () => import('../views/InvoiceInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminInvoicePendingDetails' },
            },
          },
        ],
      },
    ]
  },
  {
    path: 'admin/invoice_drafts',
    name: 'InvoiceDraft',
    component: {
      name: 'AdminInvoiceDrafts',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'invoice_draft',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminInvoiceDraftIndex',
        component: () => import('../views/InvoicesIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'AdminInvoiceDraftNew',
        component: () => import('../views/InvoiceInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'AdminInvoicesDraftIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminInvoiceDraftShow',
        component: () => import('../views/InvoiceShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminInvoicesDraftIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminInvoiceDraftDetails',
            component: () => import('../views/InvoiceDetails.vue'),
            meta: {
              backRoute: { name: 'AdminInvoicesDraftIndex' },
            },
          },
          {
            path: 'logs',
            name: 'AdminInvoiceDraftLogs',
            component: () => import('../views/InvoiceLogs.vue'),
            meta: {
              backRoute: { name: 'AdminInvoicesDraftIndex' },
              resource: 'log',
            },
          },
          {
            path: 'edit',
            name: 'AdminInvoiceDraftEdit',
            component: () => import('../views/InvoiceInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminInvoiceDraftDetails' },
            },
          },
        ],
      },
    ]
  },
];

const pubRoutes = [
  {
    path: '/public/invoices',
    name: 'PublicInvoice',
    component: {
      name: 'PublicInvoice',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'invoice',
      layout: 'Public',
      publicRoute: true,
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: ':id(\\d+)',
        name: 'PublicInvoiceShow',
        component: () => import('../views/public/InvoicePublicShow.vue'),
        meta: {
          layout: 'Public',
          publicRoute: true,
        },
      }
    ],
  },
];

OCRoutes.forEach(route => router.addRoute('OC', route));
pubRoutes.forEach(route => router.addRoute(route));
